import React, { Component } from 'react'

import FeedbackText from './Text'

class FeedbackMultiText extends Component {
  render() {
    const { inputProps = {}, ...others } = this.props
    inputProps.multiLine = true
    inputProps.rows = 2
    return <FeedbackText inputProps={inputProps} {...others} />
  }
}

export default FeedbackMultiText



// WEBPACK FOOTER //
// ./src/addons/feedback/types/MultiText.js